import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getApiClient, initializeApiClient } from "../../../Services/apiService";
import { logDOM } from "@testing-library/react";


export const GetObObjectives = createAsyncThunk(
  "ObObjectives/GetObjectivesListByAppGuid",
  async (AI_ApplicationInformationId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/Objectives/GetObjectivesListByAppGuid",
        {
            AI_ApplicationInformationId: AI_ApplicationInformationId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const GetObjectivesById = createAsyncThunk(
    "ObObjectives/GetObjectivesById",
    async (parametrs, { rejectWithValue }) => {
      try {
        await initializeApiClient();
        const apiClient = await getApiClient();
        const response = await apiClient.post(
          "api/Objectives/GetObjectivesById",
          parametrs
        );
  
        // Extract data from the response object
        const data = response.data.result; // Assuming response has a "data" field
        
        return data; // Return the extracted data
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );



export const AddObObjectives = createAsyncThunk(
    "ObObjectives/AddObObjectives",
    async (parametrs, { rejectWithValue }) => {
      try {
        await initializeApiClient();
        const apiClient = await getApiClient();
        const response = await apiClient.post(
          "api/Objectives/AddObjectives",
               parametrs,
        );
  
        // Extract data from the response object
        const data = response.data.result; // Assuming response has a "data" field
  
        return data; // Return the extracted data
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );



  export const DeleteObjectivesById = createAsyncThunk(
    "ObObjectives/DeleteObjectivesById",
    async (parametrs, { rejectWithValue }) => {
      try {
        await initializeApiClient();
        const apiClient = await getApiClient();
        const response = await apiClient.post(
          "api/Objectives/DeleteObjectivesById",
          parametrs
        );
  
        // Extract data from the response object
        const data = response.data.result; // Assuming response has a "data" field
  
        return data; // Return the extracted data
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );



  export const EditObjectivesById = createAsyncThunk(
    "ObObjectives/EditObjectivesById",
    async (parametrs, { rejectWithValue }) => {
      try {
        await initializeApiClient();
        const apiClient = await getApiClient();
        const response = await apiClient.post(
          "api/Objectives/UpdateObjectives",
          parametrs
        );
  
        // Extract data from the response object
        const data = response.data.result; // Assuming response has a "data" field
  
        return data; // Return the extracted data
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );



const ObjectivesReducer = createSlice({
  name: "BI_TimelineInformation",
  initialState: {
    ObjectivesList: {},
    loadingObjectivesList: false,
    errorObjectivesList: null,


    AddBI_TimelineInformation: {},
    loadingAddBI_TimelineInformation: false,
    errorAddBI_TimelineInformation: null,

    Objectives: {},
    loadingObjectives: false,
    errorObjectives: null,


    DeleteObjectives: {},
    loadingDeleteObjectives: false,
    errorDeleteObjectives: null,



    EditObjectives: {},
    loadingEditObjectives: false,
    errorEditObjectives: null,
  },
  reducers: {

    
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetObObjectives.pending, (state, action) => {
        state.loadingObjectivesList = true;
        state.ObjectivesList = action.payload;
        state.errorObjectivesList = null;
      })
      .addCase(GetObObjectives.fulfilled, (state, action) => {
        state.loadingObjectivesList = false;
        state.ObjectivesList = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetObObjectives.rejected, (state, action) => {
        state.loadingObjectivesList = false;
        state.errorObjectivesList = action.payload;
      })
      ///////////////////////////////////////////////////////
      
      .addCase(AddObObjectives.pending, (state, action) => {
        state.loadingAddBI_TimelineInformation = true;
        state.AddBI_TimelineInformation = action.payload;
        state.errorAddBI_TimelineInformation = null;
      })
      .addCase(AddObObjectives.fulfilled, (state, action) => {
        state.loadingAddBI_TimelineInformation = false;
        state.AddBI_TimelineInformation = action.payload; // Assuming payload has the desired data
      })
      .addCase(AddObObjectives.rejected, (state, action) => {
        state.loadingAddBI_TimelineInformation = false;
        state.AddBI_TimelineInformation = action.payload;
      })
      ////////////////////////////////////////////////////
      
      .addCase(GetObjectivesById.pending, (state, action) => {
        state.loadingObjectives = true;
        state.Objectives = action.payload;
        state.errorObjectives = null;
      })
      .addCase(GetObjectivesById.fulfilled, (state, action) => {
        state.loadingObjectives = false;
        state.Objectives = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetObjectivesById.rejected, (state, action) => {
        state.loadingObjectives = false;
        state.Objectives = action.payload;
      })
      ///////////////////////////////////////////////////////////
      .addCase(DeleteObjectivesById.pending, (state, action) => {
        state.loadingDeleteObjectives = true;
        state.DeleteObjectives = action.payload;
        state.errorDeleteObjectives = null;
      })
      .addCase(DeleteObjectivesById.fulfilled, (state, action) => {
        state.loadingDeleteObjectives = false;
        state.DeleteObjectives = action.payload; // Assuming payload has the desired data
      })
      .addCase(DeleteObjectivesById.rejected, (state, action) => {
        state.loadingDeleteObjectives = false;
        state.DeleteObjectives = action.payload;
      })
      ///////////////////////////////////////////////////////////
      .addCase(EditObjectivesById.pending, (state, action) => {
        state.loadingEditObjectives = true;
        state.EditObjectives = action.payload;
        state.errorEditObjectives = null;
      })
      .addCase(EditObjectivesById.fulfilled, (state, action) => {
        state.loadingEditObjectives = false;
        state.EditObjectives = action.payload; // Assuming payload has the desired data
      })
      .addCase(EditObjectivesById.rejected, (state, action) => {
        state.loadingEditObjectives = false;
        state.EditObjectives = action.payload;
      })
  },
});
export const { SetBI_TimelineInformation } = ObjectivesReducer.actions;

export default ObjectivesReducer.reducer;
